(function () {
  const SELECTOR = "[data-ambassador-bundle-button]";

  document.addEventListener("click", async function (event) {
    const button = event.target.closest(SELECTOR);
    if (!button) {
      return;
    }

    event.preventDefault();

    const bikeVariantId = Number(button.dataset.bikeVariantId);
    const accessoryHandle = button.dataset.accessoryHandle || "";
    const accessoryVariantId = button.dataset.accessoryVariantId
      ? Number(button.dataset.accessoryVariantId)
      : null;
    const redirectMode = button.dataset.redirectMode || "cart";
    const bikeQuantity = Number(button.dataset.bikeQuantity || "1");
    const accessoryQuantity = Number(button.dataset.accessoryQuantity || "1");

    if (!bikeVariantId) {
      console.error("Missing data-bike-variant-id on ambassador bundle button.");
      return;
    }

    setButtonState(button, true, "Adding...");

    try {
      const items = [
        {
          id: bikeVariantId,
          quantity: bikeQuantity,
        },
      ];

      const accessoryVariant = accessoryHandle
        ? await findAvailableAccessoryVariant(accessoryHandle, accessoryVariantId)
        : null;

      if (accessoryVariant) {
        items.push({
          id: accessoryVariant.id,
          quantity: accessoryQuantity,
          properties: {
            _auto_added_accessory: "true",
          },
        });
      }

      await addItemsToCart(items);

      if (redirectMode === "checkout") {
        window.location.href = "/checkout";
      } else {
        window.location.href = "/cart";
      }
    } catch (error) {
      console.error("Failed to add ambassador bundle.", error);
      setButtonState(button, false, "Try again");
    }
  });

  async function findAvailableAccessoryVariant(accessoryHandle, preferredVariantId) {
    const response = await fetch(`/products/${accessoryHandle}.js`);
    if (!response.ok) {
      return null;
    }

    const product = await response.json();
    const variants = Array.isArray(product.variants) ? product.variants : [];

    if (preferredVariantId) {
      const preferred = variants.find((variant) => variant.id === preferredVariantId && variant.available);
      if (preferred) {
        return preferred;
      }
    }

    return variants.find((variant) => variant.available) || null;
  }

  async function addItemsToCart(items) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: items }),
    });

    if (!response.ok) {
      throw new Error(`Cart add failed with status ${response.status}`);
    }

    return response.json();
  }

  function setButtonState(button, disabled, fallbackText) {
    button.disabled = disabled;
    if (disabled) {
      button.dataset.originalText = button.textContent || "";
      button.textContent = fallbackText;
      return;
    }

    if (button.dataset.originalText) {
      button.textContent = button.dataset.originalText;
    }
  }
})();
